export default __webpack_public_path__ + "static/media/rocket_anim_68.acda5154.png";